import _ from 'lodash';
import {default_dfp_config} from './dfp_config_default';
import Utils from "../../common/Utils";

const config = default_dfp_config;
config.ad_config_id = 0;
config.ad_config_name = 'e4e';
config.is_coppa = false;
config.is_hb = true;
const targetingMap = {}

const params = Utils.getUrlParams()
if (params['ab_test']) {
    targetingMap['ab_test'] = params['ab_test'].split('_')[0];
    targetingMap['ab_test_var'] = params['ab_test']
}
config.targetingMap = targetingMap;
export default config;
